import validate from "/usr/src/app/content/n3-promos-0e54dd17-b213-43ca-aab6-38d365f16ee2/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-promos-0e54dd17-b213-43ca-aab6-38d365f16ee2/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}